import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetEnterpriseInviteRequest,
    GetEnterpriseInviteResponse
} from "./types";

export { apiName };

const getEnterpriseInvite = getCallable<GetEnterpriseInviteRequest, GetEnterpriseInviteResponse>(
    apiName,
    "getEnterpriseInvite",
    {
        ...endpoints.getEnterpriseInvite,
        composer: request => {
            return {
                url: `/enterpriseInvites/${request.inviteId}`,
                options: {
                    method: "GET"
                }
            };
        }
    });

export const callables = {
    getEnterpriseInvite
};
